import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f61fb1f")

_pushScopeId("data-v-0f61fb1f")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Featured Classes")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("LATEST")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("LATEST")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("LATEST")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("LATEST")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("LATEST")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("LATEST")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("LATEST")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("LATEST")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          _createVNode(_component_navbar)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, null, {
              default: _withId(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withId(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "3",
                      "size-md": "4",
                      "size-sm": "12"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, { class: "category-card" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "3",
                      "size-md": "4",
                      "size-sm": "12"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, { class: "category-card" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "3",
                      "size-md": "4",
                      "size-sm": "12"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, { class: "category-card" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "3",
                      "size-md": "4",
                      "size-sm": "12"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, { class: "category-card" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "3",
                      "size-md": "4",
                      "size-sm": "12"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, { class: "category-card" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "3",
                      "size-md": "4",
                      "size-sm": "12"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, { class: "category-card" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "3",
                      "size-md": "4",
                      "size-sm": "12"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, { class: "category-card" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "3",
                      "size-md": "4",
                      "size-sm": "12"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, { class: "category-card" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_bottombar)
    ]),
    _: 1
  }))
})